import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FixturesByRoundWidget from "./components/widgets/FixturesByRoundWidget";
import StandingsWidget from "./components/widgets/StandingsWidget";
import PreviewPage from "./pages/PreviewPage";

const AppRouter = () => (
  <BrowserRouter>
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Navigate replace to="/preview?competitionId=39&widget=standings" />
        }
      />
      <Route path="/preview" element={<PreviewPage />} />
      <Route path="/standings" element={<StandingsWidget />} />
      <Route path="/fixtures" element={<FixturesByRoundWidget />} />
    </Routes>
  </BrowserRouter>
);

export default AppRouter;
